import { Injectable } from '@angular/core';
import { DataCollectorService } from '../data_collector_services/data_collector_service.service';
@Injectable({
    providedIn: 'root'
})
export class LineItemService {
    get lineItemAPIUrls(): any{
        return {
            productUrl: `${this.dataCollectorService.baseurl()}/product`,
            productGroupUrl: `${this.dataCollectorService.baseurl()}/product/group`,
            productLocationUrl: `${this.dataCollectorService.baseurl()}/products/location`,
            productCategoryUrl: `${this.dataCollectorService.baseurl()}/products/category`
        };
    }

    constructor(private dataCollectorService: DataCollectorService) {
    }

    getProductGroupDetails(productUID: string): string {
        return `${this.dataCollectorService.baseurl()}/product/group/${productUID}`;
    }

    setGroupLocationPreference(lineItems: any,defaultPreferredLocationUid: any): void{
        if(!lineItems?.length){
          return;
        };
        if(!defaultPreferredLocationUid){
          return;
        };
      
        lineItems?.forEach((item: any) => {
          if(item?.product_type === 'BUNDLE'){
            const associatedProducts = item?.associated_products;
            if(!associatedProducts?.length){
              return;
            };
    
            associatedProducts?.forEach(element => {
              const locationAvailability = element?.location_availability;
              if(!locationAvailability?.length){
                return;
              };
    
              if(locationAvailability?.some(locationItem => locationItem?.location?.location_uid === defaultPreferredLocationUid)){
                element['location_uid'] = defaultPreferredLocationUid;
              }
            });
          }else{
            const locationAvailability = item?.product_ref_id?.location_availability;
            if(!locationAvailability?.length){
              return;
            };
    
            if(locationAvailability?.some(locationItem => locationItem?.location?.location_uid === defaultPreferredLocationUid)){
              item.location_uid = defaultPreferredLocationUid;
            };
          }
        });
      };
}
